module.exports = __webpack_public_path__ + "img/Liechtenstein.72f0eaf0.png";